export function scaleCanvas(canvas: HTMLCanvasElement, width: number, height: number) {
  const scaleFactor = window.devicePixelRatio || 1;
  const context = canvas.getContext('2d');

  canvas.width = width * scaleFactor;
  canvas.height = height * scaleFactor;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  if (context) {
    context.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
    context.imageSmoothingEnabled = false;
  }
}

export function clearCanvas(canvas: HTMLCanvasElement) {
  const context = canvas.getContext('2d');

  if (!context) {
    return;
  }

  context.clearRect(0, 0, canvas.width, canvas.height);
}
